export class TipoCredito {
  id : BigInteger;
  cod : String;
  nombre : String;
  descripcion : String;
}
